import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { Credential } from '@/types/credentials'

interface credentialsInitialState {
  credentials: Credential[],
  pagination: {
    total: number;
    limit: number;
    offset: number;
  }
}

const initialState: credentialsInitialState = {
  credentials: [],
  pagination: {
    total: 0,
    limit: 10,
    offset: 0
  }
}

const setCredentials = (
  state: credentialsInitialState = initialState,
  action: PayloadAction<Credential[]>
) => {
  return {
    ...state,
    credentials: action.payload
  }
}

const setPagination = (
  state: credentialsInitialState = initialState,
  action: PayloadAction<{ total: number; limit: number; offset: number }>
) => {
  return {
    ...state,
    pagination: action.payload
  }
}

const reset = () => initialState

const credentialsSlice = createSlice({
  name: 'credentials',
  initialState,
  reducers: {
    setCredentials,
    setPagination,
    reset
  }
})

export const credentialReducer = credentialsSlice.reducer
export const credentialActions = credentialsSlice.actions
